import { render, staticRenderFns } from "./AnalyticsIcon.vue?vue&type=template&id=2897d478&scoped=true"
import script from "./AnalyticsIcon.vue?vue&type=script&lang=js"
export * from "./AnalyticsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897d478",
  null
  
)

export default component.exports